import React from "react";
import { useMutation } from '@apollo/client';
import { useSelector, useDispatch } from 'react-redux';
import { setpublisherGlobalData } from '../../redux/currentpublisher/publisherGlobalDataSlice.js';
import { toaster } from 'evergreen-ui';

// ------- FUNCTIONS
import { makeInputs } from '../../util.js';

// ------- QUERIES/MUTATIONS
import CREATE_CUSTOMERCLASS_MUTATION from "../../graphql/mutations/PublisherData/CreateCustomerClass.js";
import CREATE_PAYMENTTERM_MUTATION from "../../graphql/mutations/PublisherData/CreatePaymentTerm.js";

// ------- COMPONENTS
import {
  ForeignKeyDropDownInput,
  TextInputFieldInput,
  TextareaFieldInput,
  CheckboxInput,
} from "../../inputs/index.js";

import {
  Pane,
  Paragraph,
  Combobox,
  FormField,
} from 'evergreen-ui'

// Import the country list
//import { ALL_COUNTRIES } from '../../utils/countries';

function CustomerForm(props) {
  const currentpublisher = useSelector((state) => state.currentpublisher.value);
  const publisherGlobalData = useSelector((state) => state.publisherGlobalData.value);
  const dispatch = useDispatch();

  const [createCustomerClass, { classdata }] = useMutation(CREATE_CUSTOMERCLASS_MUTATION);
  const [createPaymentTerm, { termdata }] = useMutation(CREATE_PAYMENTTERM_MUTATION);

  // Safety check for staged data - AFTER all hooks have been called
  if (!props.staged) {
    return <Pane>Loading customer data...</Pane>;
  }

  const handleAddNewCustomerClass = async (val) => {
    const classes = [].concat(publisherGlobalData.customerclasses);
    try {
      const results = await createCustomerClass({
        variables: {
          publisherId: String(currentpublisher.id),
          value: val
        }
      });

      const newClass = {
        id: results.data.createCustomerClass.customerClass.id,
        value: results.data.createCustomerClass.customerClass.value
      };
      classes.push(newClass);
      dispatch(setpublisherGlobalData({ customerclasses: classes }));
      props.handleUpdateStaged({ key: "customerClass", val: newClass });
    } catch (error) {
      toaster.danger(`Error creating customer class: ${error.message}`);
    }
  }

  const handleAddNewPaymentTerm = async (val) => {
    const terms = [].concat(publisherGlobalData.paymentterms);
    try {
      const results = await createPaymentTerm({
        variables: {
          publisherId: String(currentpublisher.id),
          value: val
        }
      });

      const newTerm = {
        id: results.data.createPaymentTerm.paymentTerm.id,
        value: results.data.createPaymentTerm.paymentTerm.value
      };
      terms.push(newTerm);
      dispatch(setpublisherGlobalData({ paymentterms: terms }));
      props.handleUpdateStaged({ key: "paymentTerms", val: newTerm });
    } catch (error) {
      toaster.danger(`Error creating payment term: ${error.message}`);
    }
  }

  // const handleCountrySelect = (selectedCountry) => {
  //   props.handleUpdateStaged({
  //     key: "country",
  //     val: {
  //       code: selectedCountry.code,
  //       name: selectedCountry.name
  //     }
  //   });
  // }

  const inputs = {
    firstName: { width: 200, comp: TextInputFieldInput, formLabel: "First Name", handleChange: props.handleUpdateStaged, group: 1, opts: { marginRight: 32 } },
    lastName: { width: 200, comp: TextInputFieldInput, formLabel: "Last Name", handleChange: props.handleUpdateStaged, group: 1 },
    company: { width: 400, comp: TextInputFieldInput, formLabel: "Company Name", handleChange: props.handleUpdateStaged, group: 11 },
    adminNotes: { width: 400, comp: TextareaFieldInput, formLabel: "Account Notes", handleChange: props.handleUpdateStaged, group: 3 },
    outOfBusiness: { width: 200, comp: CheckboxInput, formLabel: "Out Of Business?", handleChange: props.handleUpdateStaged, group: 22 },
    customerClass: { width: 200, comp: ForeignKeyDropDownInput, formLabel: "Customer Class", handleChange: props.handleUpdateStaged, handleAddNew: handleAddNewCustomerClass, group: 2, values: publisherGlobalData.customerclasses, opts: {new:true} },
    paymentTerms: { width: 200, comp: ForeignKeyDropDownInput, formLabel: "Payment Terms", handleChange: props.handleUpdateStaged, handleAddNew: handleAddNewPaymentTerm, group: 2, values: publisherGlobalData.paymentterms, opts: { marginRight: 32, new:true } },
  }

  // loop over the staged array to make the columns
  const formInputs = makeInputs(props.staged, inputs, props.editing);

  return (
    <Pane>
      <Pane display="flex" justifyContent="space-between" >
        <Paragraph size={400} fontWeight="bold" color="#5e5e5e">CUSTOMER</Paragraph>
        <Pane marginTop={4}>          {formInputs.group22}
        </Pane>
      </Pane>

      {formInputs.group11}

      <Pane display="flex">
        {formInputs.group1}
      </Pane>

      <Pane display="flex">
        {formInputs.group2}
      </Pane>

      {/* Country dropdown - Always show */}
      {/* <Pane marginY={16}>
        <FormField label="Country" marginBottom={16}>
          <Combobox
            items={ALL_COUNTRIES}
            itemToString={item => item ? item.name : ''}
            selectedItem={props.staged.country && props.staged.country.code ?
              ALL_COUNTRIES.find(c => c.code === props.staged.country.code) : null}
            onChange={handleCountrySelect}
            placeholder="Select a country..."
            width={400}
            disabled={!props.editing}
          />
        </FormField>
      </Pane> */}

      {formInputs.group3}
    </Pane>
  )
}

export default CustomerForm;
